<template>
  <div>
    <!--<left-menu-admin menuActive="0" :sessionData="session"></left-menu-admin>-->
    <v-main>
      <div class="col-md-12 ml-sm-auto col-lg-12 px-4">
        <!--<v-breadcrumbs :items="breadcrumbs"></v-breadcrumbs>-->
        <v-row>
          <v-col cols="12">
            <left-emp-menu></left-emp-menu>
          </v-col>
          <v-col>
            <v-row>
              <v-col cols="12">
                <v-card-title class="lighten-5">
                  แจ้งปัญหาข้อมูล
                  <v-icon color="#871B12">mdi-comment-alert </v-icon>
                </v-card-title>
                <v-form ref="form_add" v-model="valid_add" lazy-validation>
                  <v-row>
                    <v-col cols="12">
                      <v-select
                        :items="address_status"
                        v-model="formAdd.empIssueInfoTopic"
                        :rules="nameRules"
                        label="หัวข้อแจ้งปัญหา"
                        required
                        dense
                        outlined
                        placeholder="Select..."
                      ></v-select>
                    </v-col>

                    <v-col cols="12">
                      <v-textarea
                        rows="3"
                        row-height="25"
                        label="รายละเอียดปัญหา เช่น ข้อมูลวันเดือนปีเกิดผิด แก้เป็น 2000-01-01 หรือ บัตรประชาชนไม่ถูกต้อง"
                        v-model="formAdd.empIssueInfoDetail"
                        :rules="nameRules"
                        :counter="200"
                        maxlength="200"
                        required
                        dense
                        outlined
                        hint="* กรุณากรอกข้อมูลความเป็นจริง"
                        persistent-hint
                      ></v-textarea>
                    </v-col>
                  </v-row>
                  <v-btn
                    small
                    v-if="formAdd.empIssueInfoDetail"
                    color="success"
                    :disabled="!valid_add"
                    @click="addData()"
                  >
                    บันทึกข้อมูล
                  </v-btn>
                </v-form>
                 <v-divider class="mx-4"></v-divider>
                 <v-card-title class="lighten-5">
                  ประวัติแจ้งปัญหาข้อมูล
                  <v-icon color="#871B12">mdi-comment-alert </v-icon>
                </v-card-title>

                <div v-for="(items, index) in dataInfo" :key="index">
                  <v-card class="mx-auto" max-width="100%" v-if="items.STATUS !== 'เรียบร้อย'">
                    <v-subheader> {{ items.empIssueInfoTopic }} : {{ items.CREATE_DATE | moment }}</v-subheader>
                    <v-card-text>
                      <v-col cols="12">
                        <v-textarea
                          rows="3"
                          row-height="25"
                          label="รายละเอียดปัญหา"
                          v-model="items.empIssueInfoDetail"
                          :rules="nameRules"
                          disabled
                          required
                          dense
                          outlined
                        ></v-textarea>
                      </v-col>
                    </v-card-text>
                    <v-card-actions v-if="rollHR">
                      <v-btn
                        text
                        color="teal accent-4"
                        @click="approveData(items)"
                      >
                        รอดำเนินการ
                      </v-btn>
                    </v-card-actions>
                  </v-card>
                </div>

                <v-row no-gutters> </v-row>
              </v-col>
            </v-row>
          </v-col>
        </v-row>
      </div>
    </v-main>
  </div>
</template>
<script>
import axios from 'axios' // api
import EmpMenu from './EmployeeMenu.vue'
import moment from 'moment' // แปลง date

export default {
  components: {
    'left-emp-menu': EmpMenu,
    moment
  },
  data () {
    return {
      rollHR: false,
      value: 1,
      PK: '',
      path: '/emp_issue/', // Path Model
      // Menu Config
      // breadcrumbs: [],
      // End Menu Config
      dataReady: true,
      dateTime: '', // Generate DateTime
      date: new Date().toISOString().substr(0, 10),
      valid_add: true,
      valid_edit: true,
      session: this.$session.getAll(),
      formAdd: {
        empIssueInfoId: '',
        empIssueInfoTopic: '',
        empIssueInfoDetail: '',
        empCode: '',
        userName: '',
        STATUS: 'รอดำเนินการ'
      },
      dataInfo: [],
      formUpdate: {
        empIssueInfoId: '',
        empIssueInfoTopic: '',
        empIssueInfoDetail: '',
        empCode: this.$session.getAll().data.empCode,
        userName: '',
        STATUS: ''
      },
      formUpdateItem: {
        empIssueInfoId: '',
        empIssueInfoTopic: '',
        empIssueInfoDetail: '',
        empCode: '',
        userName: '',
        STATUS: ''
      },
      nameRules: [(v) => !!v || 'Input is required'],
      json_meta: [
        [
          {
            key: 'charset',
            value: 'utf-8'
          }
        ]
      ],
      // End Export Config
      empIssueInfoId: '',
      dataEmp: '',
      address_status: [
        'ข้อมูลส่วนตัว',
        'ข้อมูลที่อยู่',
        'ข้อมูลประวัติครอบครัว',
        'ข้อมูประวัติการศึกษา',
        'ช้อมูลประสบการณ์ทำงาน',
        'ประกันสุขภาพ',
        'ประวัติการทำงาน'
      ]
    }
  },
  async mounted () {
    this.dataReady = false
    this.getGetTokenForEmployee()
    await this.checkRollHR()
    this.checkEmpData()
  },
  filters: {
    moment: function (date) {
      return moment(date).locale('th').add(543, 'year').format('LL')
    }
  },
  methods: {
    validate (Action) {
      switch (Action) {
        case 'ADD':
          this.$nextTick(() => {
            let self = this
            self.$refs.form_add.validate()
          })
          break
        default:
          break
      }
    },
    checkRollHR () {
      // // console.log(localStorage.getItem('rollHR'))
      if (localStorage.getItem('roll') === 'HR') {
        this.rollHR = true
      }
    },
    async checkEmpData () {
      this.dataEmp = JSON.parse(localStorage.getItem('dataByHR'))
      if (localStorage.getItem('roll')) {
        // this.$router.push('/HRM/Employee/EmployeeInfo')
        this.SubmitDataById()
      } else {
        this.$router.push(
          '/Core/Login'
        )
      }
    },
    async SubmitDataById () {
      this.dataInfo = []
      await axios
        .get(
          // eslint-disable-next-line quotes
          this.DNS_IP +
            this.path +
            'getEmpCode?empCode=' +
            this.dataEmp.empCode,
          {
            headers: {
              'Application-Key': localStorage.getItem('ApplicationKey')
            }
          }
        )
        .then(async (response) => {
          this.dataReady = true
          if (response.data) {
            Object.assign(this.formUpdate, response.data)
            delete this.formUpdate['LAST_DATE']
            delete this.formUpdate['CREATE_DATE']
            delete this.formUpdate['RECORD_STATUS']
            this.dataInfo = response.data
          }
        })
        // eslint-disable-next-line handle-callback-err
        .catch((error) => {
          this.dataReady = true
          console.log('error function SubmitDataById : ', error)
        })
    },
    async addData () {
      var emp = JSON.parse(localStorage.getItem('data'))
      //
      //
      // สำหรับ เพิ่มข้อมูล
      // ต้องระบุ Create / Last User ว่าใครเป็นคนสร้าง
      //
      this.formAdd.CREATE_USER = emp.userName
      this.formAdd.LAST_USER = emp.userName

      // // // // // // // // // // // // // // // // // // // // // // // // // // // // // //
      //
      // กำหนด Code ของรายการ * อย่าลืมเปลี่ยน field
      //
      this.formAdd.empCode = emp.empCode
      // // // // // // // // // // // // // // // // // // // // // // // // // // // // // // //

      // console.log('form', JSON.stringify(this.formAdd))

      this.dataReady = false
      this.addDataSubmit()
    },
    async addDataSubmit () {
      // console.log(this.formAdd)
      this.$swal({
        title: 'ต้องการ แจ้งปัญหาข้อมูล ใช่หรือไม่?',
        type: 'question',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#b3b1ab',
        confirmButtonText: 'ใช่',
        cancelButtonText: 'ไม่'
      })
        .then(async (response) => {
          delete this.formAdd['empIssueInfoId']
          await axios
            .post(
              // eslint-disable-next-line quotes
              this.DNS_IP + this.path + "add",
              this.formAdd,
              {
                headers: {
                  'Application-Key': localStorage.getItem('ApplicationKey')
                }
              }
            )
            .then(async (response) => {
              if (response.status === 200) {
                this.$swal('เรียบร้อย', 'เพิ่มข้อมูล เรียบร้อย', 'success')
                this.dataReady = true
                this.linenotify(this.formAdd)
                this.SubmitDataById()
              }
            })
            // eslint-disable-next-line handle-callback-err
            .catch((error) => {
              console.log('error function addDataGlobal : ', error)
              this.dataReady = true
            })
        })
        .catch((error) => {
          console.log('error function addData : ', error)
          this.dataReady = true
        })
    },
    async approveData (d) {
      var emp = JSON.parse(localStorage.getItem('data'))
      this.$swal({
        title: 'ท่านได้ดำเนินการแล้ว ใช่หรือไม่?',
        type: 'question',
        showCancelButton: true,
        confirmButtonColor: '#fa0202',
        cancelButtonColor: '#b3b1ab',
        confirmButtonText: 'ใช่',
        cancelButtonText: 'ไม่'
      }).then(async (result) => {
        let ds = {
          LAST_USER: emp.userName
        }

        await axios
          .post(
            // eslint-disable-next-line quotes
            this.DNS_IP + this.path + "approve/" + d.empIssueInfoId,
            ds,
            {
              headers: {
                'Application-Key': this.$session.getAll().ApplicationKey
              }
            }
          )
          .then(async (response) => {
            // Debug response
            // console.log('editDataGlobal DNS_IP + PATH + edit/', response)
            this.$swal('เรียบร้อย', 'ลบข้อมูล เรียบร้อย', 'success')
            this.SubmitDataById()
          })
          // eslint-disable-next-line handle-callback-err
          .catch((error) => {
            this.dataReady = true
            console.log('error function editDataGlobal : ', error)
          })
      })
      // console.log(this.datalistFrame)
    },
    async linenotify (dt) {
      var emp = JSON.parse(localStorage.getItem('dataByHR'))
      var text = {
        message: `[${emp.empCode}] ${emp.empFull_NameTH}\n\nหัวข้อแจ้งปัญหา : ${dt.empIssueInfoTopic}\n\nรายละเอียดแจ้งปัญหา :  ${dt.empIssueInfoDetail} \n\n\n https://liff.line.me/1654154168-M2EgzyY2?empCode=${emp.empCode}`
      }

      await axios
        .post(
          // eslint-disable-next-line quotes
          this.DNS_IP + "/line/notify",
          text
        )
        .then(async (response) => {
          // console.log(response)
        })
        // eslint-disable-next-line handle-callback-err
        .catch((error) => {
          console.log('linenotify: ', error)
        })
    }
  }
}
</script>
<style scope>
.lighten-5 {
  font-family: Kanit;
  font-style: normal;
  font-weight: 500;
  font-size: 20px;
  line-height: 20px;

  color: #871b12;
}
</style>



// WEBPACK FOOTER //
// src/components/HRM/Employee/EmployeeInfoIssue.vue